import PropTypes from 'prop-types'
import { createContext, useContext, useEffect, useState } from 'react'
import {
  addGroup,
  getAllGroups,
  getAllUsers,
  getUserById,
  modifyUser,
  updateGroup,
} from '../api/endpoints'

import { useAuth } from '../Contexts/AuthContext';


const DashboardModalContext = createContext()

export const useDashboardModalContext = () => useContext(DashboardModalContext)

export const DashboardModalProvider = ({ children }) => {
  const [groups, setGroups] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null) // Can be a user or a group

  const { hasPermission } = useAuth();


 useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const groupsData = await getAllGroups();
      setGroups(groupsData);
      
      if (hasPermission('admin:manage_users')) {
        const usersData = await getAllUsers();
        setUsers(usersData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, [hasPermission]);

  const fetchUserById = async userId => {
    try {
      const user = await getUserById(userId)
      setSelectedItem(user)
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }

  const handleSubmitUser = async userData => {
    setLoading(true)
    try {
      await modifyUser(selectedItem.id, userData)
      setLoading(false)
      return 'User updated successfully'
    } catch (error) {
      setLoading(false)
      throw new Error('Error updating user')
    }
  }
  const handleSubmitGroup = async groupData => {
    const { name, role, description } = groupData
    const payload = { nom: name, role, description }

    if (selectedItem?.id) {
      await updateGroup(selectedItem.id, payload)
    } else {
      await addGroup(payload)
    }
    setSelectedItem(null)
  }

  DashboardModalProvider.propTypes = {
    children: PropTypes.node.isRequired,
  }

  return (
    <DashboardModalContext.Provider
      value={{
        groups,
        users,
        selectedItem,
        setSelectedItem,
        loading,
        fetchUserById,
        handleSubmitUser,
        handleSubmitGroup,
      }}
    >
      {children}
    </DashboardModalContext.Provider>
  )
}
